import styles from './styles.module.scss';
import { t } from 'i18next';

type Toogle = {
  checked: boolean;
  onClick: () => void;
}

function Toggle(props : Toogle) : JSX.Element {
  return (
    <div className={styles['biobar-notifications-toggle']}>
      <p>{t('biobar.notification.header.action')}</p>
      <label className={styles['switch']}>
        <input type="checkbox" onClick={props.onClick} checked={props.checked}/>
        <div className={`${styles['slider']} ${styles['round']}`}></div>
      </label>
    </div>
  );
}

export default Toggle;